import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { AssignedComp } from './assigned';
import { AddNewUser, GetProcessList, GetUserDetails, UpdateUserDetails } from '../../models/process';
import { pnkstore } from '../../stores/pnk-store';
import { useUserStore } from '../../stores/user-store';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { GetAllProject, GetAreasList, GetCitiesList, GetDistrictList, GetStatesList } from '../../models/project';
import { AddNewLead, AssignLeadsManuallly, AssignLeadsManually, GetAllLeads, GetLeadsCountForAssign, UpdateLead, UpdateLeadDesc } from '../../models/leads';
import { GetProfileList } from '../../models/profile';
import { GetUserList } from '../../models/user';

export const Assigned = (props) => {
    const userData = useUserStore;
    const [AssignFormData, setAssignFormData] = useState({
        'txtLeadAssignStartDate': '',
        'txtLeadAssignEndDate': '',
        'ddlLeadAssignOwner': [],
    });
    const [getStateList, setGetStateList] = useState(true);
    const [stateListData, setStateListData] = useState([]);
    const [statusListData, setStatusListData] = useState([]);
    const [getCityList, setGetCityList] = useState(false);
    const [cityListData, setCityListData] = useState([]);

    const [getProfileList, setGetProfileList] = useState(true);
    const [profileListData, setProfileListData] = useState([]);
    const [getUserList, setGetUserList] = useState(true);
    const [userListData, setUserListData] = useState([]);
    const [getProjectList, setGetProjectList] = useState(true);
    const [projectList, setProjectList] = useState([]);

    const [searchLeads, setSearchLeads] = useState(false);
    const [assignLeads, setAssignLeads] = useState(false);
    const [totalLeads, setTotalLeads] = useState('');

    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertMsg, setAlertMsg] = useState('');

    const state = {
        userData: userData.getState(),
        stateListData: stateListData,
        profileListData: profileListData,
        userListData: userListData,
        showAlert: showAlert,
        alertMsg: alertMsg,
        alertType: alertType,
        pageType: props.page,
        statusListData: statusListData,
        totalLeads: totalLeads
    }

    useEffect(() => {

        let statusArray = ['Pending', 'RNR', 'Hold', 'Dead', 'Call Back'];

        if (props.candidateStatus === 'Shortlisted') {
            statusArray = ['In Progress', 'S-Test', 'Test Completed', 'Interview Scheduled', 'Interview Completed', 'Selected', 'Rejected'];
        }
        else if (props.candidateStatus === 'On Board') {
            statusArray = ['Joined', 'Not Joined', 'Deferred Admission'];
        }
        setStatusListData(statusArray);
    }, []);

    const HandleInputs = (e, name) => {
        let value = '';
        if (name === 'txtLeadAssignStartDate' || name === 'txtLeadAssignEndDate') {
            value = e.$d;
            value = new Date(new Date(value).getTime() - (new Date(value).getTimezoneOffset() * 60000)).toISOString().substr(0, 10).replace('T', ' ')
        }
        else {
            value = e.target.value
        }
        setAssignFormData((prev) => ({ ...prev, [name]: value }));
        if (name == 'ddlLeadSearchState') {
            setGetCityList(true)
        }

        if(name === 'txtLeadAssignStartDate' || name === 'txtLeadAssignEndDate' || name === 'ddlAssignOperation' || name === 'ddlAssignDateRange' || name === 'ddlLeadAssignDep' || name === 'ddlLeadAssignOwner'){
            setTotalLeads('');
            setAssignLeads(false);
        }

    }

    const HandleCloseAlertMsg = (type) => {
        setTimeout(() => {
            setShowAlert(false);
            setAlertType('');
            setAlertMsg('');
        }, 2000)
    }

    const ToggleFilterBox = () => {
        props.ToggleFilter()
    }

    const SearchData = () => {

        if (AssignFormData.txtLeadAssignStartDate !== '') {
            if (AssignFormData.txtLeadAssignEndDate === '') {
                setShowAlert(true);
                setAlertMsg('Please Select End Date Also');
                setAlertType('error');
                return false;
            }
        }
        props.SearchList('filter', AssignFormData);
    }

    const HandleCityListResponse = (res) => {
        if (res != false) {
            let data = res.data.districtlistresponse.rows;
            setCityListData(data);
        }
        else {
            setCityListData([]);
        }

        setGetCityList(false);
    }

    const HandleProjectListSuccessResponse = (res) => {
        if (res != false && res != 'error') {
            let projectListData = res.data.proplistresponse.rows
            setProjectList(projectListData);
        }
        else {
            setProjectList([]);
        }
        setGetProjectList(false);
    }

    const HandleStateListResponse = (res) => {
        console.log(res.data.statelistresponse.rows);
        if (res != false) {
            setStateListData(res.data.statelistresponse.rows);
        }
        else {
            setStateListData([]);
        }
        setGetStateList(false)
    }

    const HandleGetProfilesListSuccessResponse = (res) => {
        if (res != false && res != 'error') {
            console.log(res);
            let profileListData = res.data.profilelistresponse.rows
            setProfileListData(profileListData);
        }
        else {
            setProfileListData([]);
        }
        setGetProfileList(false);
    }

    const HandleGetUsersListSuccessResponse = (res) => {
        if (res != false && res != 'error') {
            console.log(res);
            let usersListData = res.data.userlistresponse.rows
            setUserListData(usersListData);
        }
        else {
            setUserListData([]);
        }
        setGetUserList(false);
    }

    const SearchLeadsForAssign = () => {

        if (AssignFormData.ddlAssignOperation == undefined || AssignFormData.ddlAssignOperation == null || AssignFormData.ddlAssignOperation.trim() == '') {
            setAssignFormData((prev) => ({ ...prev, ['ddlAssignOperationErr']: 'Select Operation' }));
            return false;
        }
        else {
            setAssignFormData((prev) => ({ ...prev, ['ddlAssignOperationErr']: '' }));
        }

        if (AssignFormData.ddlAssignOperation === 'Assign' || AssignFormData.ddlAssignOperation === 'Re-Assign' || AssignFormData.ddlAssignOperation === 'Remove') {
            if (AssignFormData.ddlAssignDateRange == undefined || AssignFormData.ddlAssignDateRange == null || AssignFormData.ddlAssignDateRange.trim() == '') {
                setAssignFormData((prev) => ({ ...prev, ['ddlAssignDateRangeErr']: 'Select Date Type' }));
                return false;
            }
            else {
                setAssignFormData((prev) => ({ ...prev, ['ddlAssignDateRangeErr']: '' }));
            }

            if (AssignFormData.ddlAssignDateRange === 'Date Range') {
                if (AssignFormData.txtLeadAssignStartDate == undefined || AssignFormData.txtLeadAssignStartDate == null || AssignFormData.txtLeadAssignStartDate.trim() == '') {
                    setAssignFormData((prev) => ({ ...prev, ['txtLeadAssignStartDateErr']: 'Select Start Date' }));
                    return false;
                }
                else {
                    setAssignFormData((prev) => ({ ...prev, ['txtLeadAssignStartDateErr']: '' }));
                }

                if (AssignFormData.txtLeadAssignEndDate == undefined || AssignFormData.txtLeadAssignEndDate == null || AssignFormData.txtLeadAssignEndDate.trim() == '') {
                    setAssignFormData((prev) => ({ ...prev, ['txtLeadAssignEndDateErr']: 'Select End Date' }));
                    return false;
                }
                else {
                    setAssignFormData((prev) => ({ ...prev, ['txtLeadAssignEndDateErr']: '' }));
                }

            }

            if (AssignFormData.ddlLeadAssignDep == undefined || AssignFormData.ddlLeadAssignDep == null || AssignFormData.ddlLeadAssignDep.trim() == '') {
                setAssignFormData((prev) => ({ ...prev, ['ddlLeadAssignDepErr']: 'Select Department' }));
                return false;
            }
            else {
                setAssignFormData((prev) => ({ ...prev, ['ddlLeadAssignDepErr']: '' }));
            }
            if (AssignFormData.ddlLeadAssignOwner == undefined || AssignFormData.ddlLeadAssignOwner == null || AssignFormData.ddlLeadAssignOwner.length == 0) {
                setAssignFormData((prev) => ({ ...prev, ['ddlLeadAssignOwnerErr']: 'Select Owner' }));
                return false;
            }
            else {
                setAssignFormData((prev) => ({ ...prev, ['ddlLeadAssignOwnerErr']: '' }));
            }
        }
        setSearchLeads(true);
    }

    const AssignLeads = () => {

        // if (AssignFormData.ddlAssignOperation === 'Assign') {
        // }

        if (AssignFormData.ddlAssignOperation === 'Assign') {
            if (AssignFormData.txtAssignedLeadsNumber == undefined || AssignFormData.txtAssignedLeadsNumber == null || AssignFormData.txtAssignedLeadsNumber.trim() == '') {
                setAssignFormData((prev) => ({ ...prev, ['txtAssignedLeadsNumberErr']: 'Enter Number of Leads' }));
                return false;
            }
            else {
                setAssignFormData((prev) => ({ ...prev, ['txtAssignedLeadsNumberErr']: '' }));
            }
             setAssignLeads(true);
        }
        else if (AssignFormData.ddlAssignOperation === 'Re-Assign') {
            if (AssignFormData.ddlLeadReAssignDep == undefined || AssignFormData.ddlLeadReAssignDep == null || AssignFormData.ddlLeadReAssignDep.trim() == '') {
                setAssignFormData((prev) => ({ ...prev, ['ddlLeadReAssignDepErr']: 'Select Department' }));
                return false;
            }
            else {
                setAssignFormData((prev) => ({ ...prev, ['ddlLeadReAssignDepErr']: '' }));
            }
            if (AssignFormData.ddlLeadReAssignOwner == undefined || AssignFormData.ddlLeadReAssignOwner == null || AssignFormData.ddlLeadReAssignOwner.trim() == '') {
                setAssignFormData((prev) => ({ ...prev, ['ddlLeadReAssignOwnerErr']: 'Select Owner' }));
                return false;
            }
            else {
                setAssignFormData((prev) => ({ ...prev, ['ddlLeadReAssignOwnerErr']: '' }));
            }

             setAssignLeads(true);
        }
        else{
            setAssignLeads(true);
        }

    }

    const HandleSearchLeadsSuccessResponse = (res) => {
        console.log(res);
        if (res !== false) {
            setTotalLeads(res.data.leadsresponse.message.value);
        }
        else {
            setTotalLeads(0);
        }
        setSearchLeads(false);
    }

    const HandleAssignLeadsSuccessResponse = (res) => {
        setAssignLeads(false);
        if(res !== false){
            ToggleFilterBox();
        }
        else{
             
        }
    }

    return (
        <Box>
            <AssignedComp
                mystate={state}
                HandleInputs={HandleInputs}
                cityListData={cityListData}

                projectList={projectList}
                AssignFormData={AssignFormData}
                ToggleFilterBox={ToggleFilterBox}
                SearchData={SearchData}
                HandleCloseAlertMsg={HandleCloseAlertMsg}
                SearchLeadsForAssign={SearchLeadsForAssign}
                AssignLeads={AssignLeads}
            />
            {((getUserList === true) ? GetUserList(pnkstore, {}, userData.getState().token, HandleGetUsersListSuccessResponse) : "")}
            {((getProfileList === true) ? GetProfileList(pnkstore, {}, userData.getState().token, HandleGetProfilesListSuccessResponse) : "")}
            {((searchLeads === true) ? GetLeadsCountForAssign(pnkstore, AssignFormData, userData.getState().token, HandleSearchLeadsSuccessResponse) : "")}
            {((assignLeads === true) ? AssignLeadsManually(pnkstore, AssignFormData, userData.getState().token, HandleAssignLeadsSuccessResponse) : "")}
        </Box>
    )
}